// Check before uploading files. The backend checks these exact IDs again under
// a transaction lock, so a newly activated primary requires fresh confirmation.
export async function confirmPrimaryLicenseReplacement({ client, apiBase, userId, licenseId, type, driverStatus, token }) {
  if (type !== "primary" || driverStatus !== "active") return [];
  const { data } = await client.get(`${apiBase}/api/driverlicense/${userId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  const conflicts = [...new Set(data.filter((row) =>
    String(row.dl_id) !== String(licenseId) && row.dl_status === "primary" && row.dl_driver_status === "active",
  ).map((row) => Number(row.dl_id)))];
  if (!conflicts.length) return [];
  return window.confirm("There is already an active Primary license. Please confirm: make the previous Primary license inactive and save this license as the active Primary?") ? conflicts : null;
}
